export enum ActionType {
	/** None is useful for a "Close" style button that just marks the notification as read */
	None = "None",
	Http = "Http",
	VuexAction = "VuexAction",
	VuexMutation = "VuexMutation",
	VueRouter = "VueRouter"
}